import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const ApprovedPreApprovalGuarantees = (
  { TabsRaw }: any,
) => (
  <GuaranteesTableRecords
    type="pre-approval"
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    tabStatus="APPROVED"
    defaultUrl={AdminRouteName.approvedPreApprovalGuaranteesRoute}
    toggleStorageId="approved-pre-approval-guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-all-guarantees-tab"
  />
);
export default ApprovedPreApprovalGuarantees;
